module.exports = __webpack_public_path__ + "static/media/profile-circle.3445636a.svg";